import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getProductPackageByIdApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getProductPackageById = createAsyncThunk('getProductPackageById', async (payload) => {
  // console.log('payload', payload);
  return await getProductPackageByIdApi(payload);
});

const getProductPackageByIdSlice = createSlice({
  name: 'getProductPackageById', // Unique Name
  initialState,
  reducers: {
    getProductPackageByIdReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProductPackageById.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getProductPackageById.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getProductPackageById.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getProductPackageByIdReset } = getProductPackageByIdSlice.actions;

export default getProductPackageByIdSlice.reducer;
